import {
  Boxes,
  CircleDollarSign,
  ClipboardCheck,
  Factory,
  FileSignature,
  FileSpreadsheet,
  FileText,
  PackageSearch,
  Store,
  Truck,
  UserCog,
} from "lucide-react";
import {
  adminNavigation,
} from "../features/admin/AdminConsole";
import {
  type SessionUser,
  type UserRole,
} from "../shared/auth/access";

export const fallbackUser: SessionUser = {
  id: "guest",
  email: "",
  name: "Yetkisiz Kullanıcı",
  initials: "—",
  title: "Oturum gerekli",
  departmentId: null,
  department: "—",
  assignedRoles: [],
  roles: ["GUEST"],
  role: "GUEST",
  roleLabel: "Yetkisiz",
  permissions: [],
  dataScope: "none",
};

export const navItems = [
  { label: "Üretim", icon: Factory },
  { label: "Üretim Raporları", icon: FileSpreadsheet },
  { label: "İş Emri Takibi", icon: ClipboardCheck },
  { label: "Depo Hazırlık", icon: Boxes },
  { label: "Etiket Talepleri", icon: FileText },
  { label: "Malzeme Planlama", icon: Factory },
  { label: "Talepler", icon: FileText },
  { label: "Teklifler", icon: PackageSearch },
  { label: "Onay Merkezi", icon: ClipboardCheck },
  { label: "Siparişler", icon: Truck },
  { label: "Tedarikçiler", icon: Store },
  { label: "Sözleşmeler", icon: FileSignature },
  { label: "Raporlar", icon: CircleDollarSign },
  { label: "DÖF Yönetimi", icon: ClipboardCheck },
];

export type PreviewRole =
  | "PLANLAMA"
  | "SATIN_ALMA"
  | "SATIN_ALMA_MUDURU"
  | "GENEL_MUDUR"
  | "KALITE_UZMANI"
  | "KALITE_MUDURU"
  | "URETIM_OPERATORU"
  | "VARDIYA_AMIRI"
  | "URETIM_YONETICISI"
  | "TEKNIK_MUDURU"
  | "DEPO_GOREVLISI"
  | "CEP_DEPO_SORUMLUSU";

export type WorkingRole = Exclude<UserRole, "GUEST">;

export const workingRoleOptions: Array<{ value: WorkingRole; label: string; }> = [
  { value: "SISTEM_YONETICISI", label: "Sistem Yöneticisi" },
  { value: "PLANLAMA", label: "Planlama" },
  { value: "SATIN_ALMA", label: "Satın Alma" },
  { value: "SATIN_ALMA_MUDURU", label: "Satın Alma Müdürü" },
  { value: "GENEL_MUDUR", label: "Genel Müdür" },
  { value: "KALITE_UZMANI", label: "Kalite Uzmanı" },
  { value: "KALITE_MUDURU", label: "Kalite Müdürü" },
  { value: "URETIM_OPERATORU", label: "Üretim Operatörü" },
  { value: "VARDIYA_AMIRI", label: "Vardiya Amiri" },
  { value: "URETIM_YONETICISI", label: "Üretim Yöneticisi" },
  { value: "TEKNIK_MUDURU", label: "Teknik Departman Müdürü" },
  { value: "DEPO_GOREVLISI", label: "Depo Görevlisi" },
  { value: "CEP_DEPO_SORUMLUSU", label: "Cep Depo Sorumlusu" },
];

export const previewRoleOptions = workingRoleOptions.filter(
  (option): option is { value: PreviewRole; label: string; } =>
    option.value !== "SISTEM_YONETICISI",
);

export const secondaryNavItems = adminNavigation.concat([
  { label: "Vardiya Formu Yönetimi", icon: ClipboardCheck },
  { label: "Profilim", icon: UserCog },
]);
